import React, { useState } from "react";
import { HiArrowNarrowLeft } from 'react-icons/hi';
import backgroundImage from '../../images/header-homepage.webp';
import logo from '../../images/logo_icon.png';
import ProgressNavbar from './Components/progressNavbar';

import EmailStep from "./ForgotPasswordSteps/emailStep";
import PasswordStep from "./ForgotPasswordSteps/passwordStep";
import SuccessStep from "./ForgotPasswordSteps/successStep";
import useDocumentTitle from "../../Common/useDocumentTitle";

export default function ForgotPasswordForm() {
  const [currentStep, setCurrentStep] = useState(0);
  const [userInfo, setUserInfo] = useState({
    email: "",
    password: "",
    secondPassword: "",
    verifyCode: "",
  });

  useDocumentTitle("Forgot Password");

  const steps = [
    { name: 'Step 1', step: 0, componentName: EmailStep },
    { name: 'Step 2', step: 1, componentName: PasswordStep },
    { name: 'Step 1', step: 2, componentName: SuccessStep },
  ]

  // Joins class names. Used for adding red borders to inputs with errors.
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

  /**
   * Displays current step component.
   * 
   * @returns React Component.
   */
  function renderCurrentStep() {
    let params = {
      userInfo: userInfo,
      setUserInfo: setUserInfo,
      currentStep: currentStep,
      setCurrentStep: setCurrentStep,
      classNames: classNames
    }

    const Component = steps[currentStep].componentName;
    return <Component {...params} />;
  }

  return (
    <>
      <div className="h-screen md:flex dark:bg-gray-900">
        <div className="flex 2xl:w-2/5 w-full justify-center py-10 items-center bg-white dark:bg-gray-900">
          <div className="w-2/3 md:w-1/2 max-w-md">
            {/* Render title and progress bar unless it's the last step (success step) */}
            {currentStep !== steps.length - 1 &&
              <>
                <div className="mt-24 sm:mt-10 flex justify-center">
                  <img
                    draggable="false"
                    className="h-16 dark:invert"
                    src={logo}
                    alt="Arctic Research Foundation Logo"
                  />
                </div>

                <h1 className="mt-10 text-2xl font-bold tracking-tight text-gray-900 sm:text-4xl text-center dark:text-white">
                  Forgot Password
                </h1>
                {currentStep === 1 &&
                  <p className="mt-2 text-center font-medium text-gray-600 dark:text-gray-400">We've sent a verification code to {userInfo.email}</p>
                }

                <div className="mb-6 mt-6">
                  <ProgressNavbar steps={steps.slice(0, 2)} currentStep={currentStep} classNames={classNames} />
                </div>
              </>
            }

            {renderCurrentStep()}

            {currentStep !== steps.length - 1 &&
              <div className="mt-4 flex justify-center">
                <a href="/signin" className="flex items-center text-sm sm:text-base font-medium text-blue-700 dark:text-blue-500"><HiArrowNarrowLeft className="w-4 h-4 mr-1" /> Back to log in</a>
              </div>
            }
          </div>
        </div>

        <div className="relative overflow-hidden lg:flex w-3/5 justify-around items-center hidden">
          <img
            draggable="false"
            className="aspect-[3/2] w-full bg-gray-50 object-cover lg:absolute lg:inset-0 lg:aspect-auto h-screen"
            src={backgroundImage}
            alt="Arctic plains landscapes"
          />
        </div>
      </div>
    </>
  )
}